import defineComponent from 'flight';

function ClickableListItem() {

    let skipClicks = ['a', 'input', 'label', 'button'];

    this.defaultAttrs({
        link: '[data-clickable-list-item-link]',
        editableCssClass: '.myt-list-editable',
        checkboxSelector: '[data-myt-checkbox]',
        ignoreClickSelector: '[data-clickable-list-ignore-click]',
        initData: {}
    });

    this._click = function (evt) {
        let evtTarget = $(evt.target),
            evtCurrentTarget = $(evt.currentTarget);

        if (this._isEditable(evtTarget, evtCurrentTarget)) {
            evt.preventDefault();
            evt.stopPropagation();
            this._checkCheckbox();
            return false;
        }

        if (this._ignoreClick(evt, evtTarget)) {
            return true;
        }

        this._preventBubblingIfOnIgnoreSelector(evtTarget, evt);

        let $clickElement = this.select('link');
        let url = $clickElement.attr('href');

        this._triggerIfHref($clickElement, url);

        return false;
    };

    this._ignoreClick = function (evt, evtTarget) {
        if (this._ignoreClickForElement(evtTarget)) {
            if (this._skipClicks(evt)) {
                return true;
            }

            let parent = $(evt.target).parent();
            if (this._skipClicksforParent(parent)) {
                return true;
            }
        }
        return false;
    };

    this._checkCheckbox = function () {
        let checkbox = this.select('checkboxSelector');

        if (checkbox && !checkbox.is(':disabled')) {
            checkbox.prop('checked', !checkbox.prop('checked'));
            this.trigger('ui:clickable-list-item:on-checkbox-click');
        }
    };

    this._ignoreClickForElement = function (evtTarget) {
        return !evtTarget.is(this.attr.ignoreClickSelector);
    };

    this._isEditable = function (evtTarget, evtCurrentTarget) {
        return evtTarget.parents(this.attr.editableCssClass).length > 0 || evtCurrentTarget.parents(this.attr.editableCssClass).length > 0;
    };

    this._skipClicks = function (evt) {
        return this._skipClicksforTag(evt.target.tagName.toLowerCase()) || this._skipClicksforTag(evt.currentTarget.tagName.toLowerCase());
    };

    this._skipClicksforParent = function (parent) {
        return parent && this._skipClicksforTag(parent.prop('tagName').toLowerCase());
    };

    this._skipClicksforTag = function (tag) {
        return skipClicks.indexOf(tag) > -1;
    };

    this._preventBubblingIfOnIgnoreSelector = function (evtTarget, evt) {
        if (evtTarget.is(this.attr.ignoreClickSelector)) {
            evt.preventDefault();
            evt.stopPropagation();
        }
    };

    this._triggerIfHref = function (element, url){
        if (url) {
            this._triggerGAEventAction(element, url);
        }

    };

    this._triggerGAEventAction = function ($clickElement, url) {
        if (!$clickElement.data('ga-action')) {
            return false;
        }

        let options = {
            action: $clickElement.data('ga-action'),
            label: $clickElement.data('ga-label')
        };

        let callbackDone = false;

        let callback = function () {
            if (callbackDone === false) { // callback should never be ran twice (ipad issue when using hitCallback + setTimeout)
                this.trigger('ui:navigate', {href: url});
            }
            callbackDone = true;
        }.bind(this);

        options.category = $clickElement.data('ga-category') ? $clickElement.data('ga-category') : (this.attr.initData.pageName || 'MyTradera - unknown');
        options.userTriggered = true;
        options.hitCallback = callback;

        this.trigger(document, 'analytics:track-event', options);
    };

    this.after('initialize', function () {
        this.$node.css('cursor', 'pointer');
        this.on('click', this._click);
    });
}

module.exports = defineComponent.component(ClickableListItem);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/clickable-list-item.js